/**
 * Created by nijin on 8/2/17.
 */

import {Injectable} from '@angular/core';

@Injectable()
export class WindowService {
  constructor() {

  }

  createWindow(url: string, name = 'Window', width = 500, height = 600, left = 100, top = 100) {
    if (url == null) {
      return null;
    }

    return window.location.href = url;
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/window/window.service.ts